import React from 'react'
import useStore from '../StateStore/store'
import * as THREE from "three"
import { playerPosition } from '../Hotspot/playerPosition'

const display = {
    display : "none"
}

const HotspotBtns = () => {


    const propogation = useStore(state => state.propogateToStall)
    const propogate = useStore((state) => state.propogateToStall.propogateTo)
    const exitState = useStore((state) => state.propogateToStall.exitButton)
    const videoDisplay = useStore (state => state.videoDisplay)

    const offset = React.useMemo(() => new THREE.Vector3(0, 5, 0), [])
    const videoOffset = React.useMemo(() => new THREE.Vector3(0, 8, 0), [])


    const next = React.useCallback(e => {
        propogation.setPlayerState(false, false)
            const type = Object.keys(propogation.currentHotspot)[0]
        let id = Object.values(propogation.currentHotspot)[0]
        const pointPosition = propogation.currentHotspot["stall"]
        const numberOfSpots = playerPosition[type]

        if(numberOfSpots.length === id+1){
            id = -1
        }
        
        const hotspotClicked = playerPosition[type][id+1]
        const currentSpot = {
            [type] : id+1,
            "stall" : pointPosition
        }

        // console.log(hotspotClicked, currentSpot)
        // console.log(currentSpot)
        offset.x = (pointPosition.x + hotspotClicked.x*Math.sign(-pointPosition.z))*1.02
        offset.z = (pointPosition.z + hotspotClicked.y*Math.sign(-pointPosition.z)) * 0.9
        // if(hotspotClicked.x2){
            videoOffset.x = (pointPosition.x + hotspotClicked.x2*Math.sign(-pointPosition.z)) * 1.02
            videoOffset.z = (pointPosition.z + hotspotClicked.y2*Math.sign(-pointPosition.z)) * 0.9
            videoOffset.y = hotspotClicked.z2
        // }
        
        const r = hotspotClicked.r < Math.PI? 1 : 0
        const side = pointPosition.z > 0 ? 1 : 0

        if(playerPosition[type][id+1].type === "videoPoint"){
            if(hotspotClicked.r2 < Math.PI){
                const s = pointPosition.z > 0 ? -1 : 1
                videoDisplay.triggerVideo(videoOffset, hotspotClicked.r2*r*s)
            }else{
                videoDisplay.triggerVideo(videoOffset, hotspotClicked.r2*side)
            }
        }else{
            videoDisplay.triggerVideo(undefined, undefined)
        }

        if(hotspotClicked.r){
            propogate(offset,hotspotClicked.r*r)
        }else{
            propogate(offset,undefined )
        }
        propogation.setHotspot(currentSpot)
        propogation.setPlayerState(true, true)
        setTimeout(() => {
            propogation.setPlayerState(false, true)
        }, 1900);

    }, [])

    const prev = React.useCallback(e => {
        propogation.setPlayerState(false, false)

        // console.log(propogation.propogateState, propogation.exitButton)        
            const type = Object.keys(propogation.currentHotspot)[0]
        let id = Object.values(propogation.currentHotspot)[0]
        const pointPosition = propogation.currentHotspot["stall"]
        const numberOfSpots = playerPosition[type]

        if(id === 0){
            id = numberOfSpots.length
        }
        
        const hotspotClicked = playerPosition[type][id-1]
        const currentSpot = {
            [type] : id-1,
            "stall" : pointPosition
        }

        // console.log(hotspotClicked, currentSpot)
        // console.log(currentSpot)
        offset.x = (pointPosition.x + hotspotClicked.x*Math.sign(-pointPosition.z))*1.02
        offset.z = (pointPosition.z + hotspotClicked.y*Math.sign(-pointPosition.z)) * 0.9
        // if(hotspotClicked.x2){
            videoOffset.x = (pointPosition.x + hotspotClicked.x2*Math.sign(-pointPosition.z)) * 1.02
            videoOffset.z = (pointPosition.z + hotspotClicked.y2*Math.sign(-pointPosition.z)) * 0.9
            videoOffset.y = hotspotClicked.z2
        // }
        
        const r = hotspotClicked.r < Math.PI? 1 : 0
        const side = pointPosition.z > 0 ? 1 : 0

        if(playerPosition[type][id-1].type === "videoPoint"){
            if(hotspotClicked.r2 < Math.PI){
                const s = pointPosition.z > 0 ? -1 : 1
                videoDisplay.triggerVideo(videoOffset, hotspotClicked.r2*r*s)
            }else{
                videoDisplay.triggerVideo(videoOffset, hotspotClicked.r2*side)
            }
        }else{
            videoDisplay.triggerVideo(undefined, undefined)
        }

        if(hotspotClicked.r){
            propogate(offset,hotspotClicked.r*r)
        }else{
            propogate(offset,undefined )
        }
        propogation.setHotspot(currentSpot)
        propogation.setPlayerState(true, true)
        setTimeout(() => {
            propogation.setPlayerState(false, true)
        }, 1900);

    }, [])
    
    // console.log(propogation.next)
    return (
        <div id="hotspotBtnCon" style={propogation.exitButton === false ? display : null} >
            <div id="exit" className="btn" onClick={(e) =>  {
                propogation.setPlayerState(false, false)
            }} 
            >EXIT</div>
            <div id="next" className="btn" onClick={next} >NEXT</div>
            <div id="prev" className="btn" onClick={prev} >PREV</div>
        </div>
    )
}

export default HotspotBtns
